module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M14.882 8.637l-1.38-1.378c-.762-.764-2.014-.748-2.794.034l-1.412 1.41c-.78.78-.836 1.992-.124 2.704l1.29 1.29-9.755 9.775c-.39.39-.706 1.154-.706 1.706v6.821a1 1 0 0 0 1 1h6.821c.552 0 1.316-.316 1.708-.708l9.773-9.755 1.29 1.29c.712.712 1.924.658 2.706-.124l1.41-1.41c.782-.782.796-2.034.036-2.794l-1.38-1.38 6.881-6.879a6 6 0 0 0 0-8.481 6 6 0 0 0-8.481 0l-6.883 6.879zM7.181 28h-3.18v-3.18l9.301-9.283 3.16 3.16L7.181 28z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eyedropper-1.js
// module id = 1138
// module chunks = 14